import Vue from 'vue'
import vuetify from './vuetify'
import store from '../store'
import axios from '../plugins/axios'

import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'

const context = {
  store,
  vuetify,
  axios
}

Vue.use(VuetifyDialog, {
  context,
  notification: {
    position: 'bottom-right',
    icon: false
  },
  warning: {
    title: 'Confirmación',
    color: 'primary',
    actions: {
      false: {
        text: 'No',
        color: 'primary',
        outlined: true,
        large: true
      },
      true: {
        text: 'Si',
        color: 'secondary',
        flat: false,
        large: true
      }
    }
  }
})
